/**
 * PSCA status codes.
 */
export enum PscaStatusEnum {
    Active = 'PSCA-Active',
    Archived = 'PSCA-Archived',
    Billing = 'PSCA-Billing',
    BillingReview = 'PSCA-Billing - Review',
    Deleted = 'PSCA-Deleted',
    FccAccepted = 'PSCA-FCC - Accepted',
    FccError = 'PSCA-FCC - Error',
    FccFeesDue = 'PSCA-FCC - Fees Due',
    FccReady = 'PSCA-FCC - Ready',
    FccReview = 'PSCA-FCC - Review',
    FccSent = 'PSCA-FCC - Sent',
    ISDayX = 'PSCA-I/S - Day X',
    ISFeeApproval = 'PSCA-I/S - Fee Approval',
    ISReady = 'PSCA-I/S - Ready',
    Objected = 'PSCA-Objected',
    PreFcc = 'PSCA-PRE-FCC',
    Received = 'PSCA-Received',
}

export const PscaFilterStatuses: PscaStatusEnum[] =
    Object.values(PscaStatusEnum);
